// aiagent 统一请求体组装：企业账号带 enterprise，个人/平台传 null；owner_* 由服务端注入，前端不传
export function agentBody(data) {
  const acctype = localStorage.getItem('acctype')
  const enterprise = ['2', '3'].includes(acctype) ? localStorage.getItem('enterprise_id') : null
  return { enterprise, data }
}

// 生成本轮对话幂等 id：turn_ + uuid（≤128 字符；同 id 7 天内重试返回缓存回复）
export function genTurnId() {
  return 'turn_' + _uuid()
}

// 当前账号是否企业（含企业管理员 3）：决定写操作入口显隐与 owner 归属
export function isEnterprise() {
  return ['2', '3'].includes(localStorage.getItem('acctype'))
}

// P5a：当前账号是否平台管理员（工具/MCP 子 Tab 数据源切换为 platform-*）
export function isAdminAcc() {
  return localStorage.getItem('acctype') === '3'
}

// P5a：工具/MCP 写权限（用户拍板：个人只读，后端实际允许个人自建，后续放开只改此处）
export function canWriteTools() {
  return ['2', '3'].includes(localStorage.getItem('acctype'))
}

// P5a：KV 行 ↔ map 互转（headers/secrets 动态行编辑共用）
export function mapToRows(map) {
  return Object.keys(map || {}).map(k => ({ k, v: map[k] }))
}

// P5a：行转 map；编辑态传 origKeys 时，被删行的原 key 补空串（后端约定 ""=删除该 key，缺失=保留）
export function rowsToMap(rows, origKeys) {
  const m = {}
  ;(rows || []).forEach(r => { if (r.k) m[r.k] = r.v })
  if (origKeys) origKeys.forEach(k => { if (!(k in m)) m[k] = '' })
  return m
}

// uuid 兜底实现（package.json 无 uuid 依赖，不新增依赖）
function _uuid() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID()
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}
